// extracted by mini-css-extract-plugin
export var dropdown = "_t5-0";
export var imageWrapper = "_t5-3";
export var itemNameContainer = "_t5-1";
export var productImage = "_t5-2";
export var spinnerWrapper = "_t5-4";